import { z } from 'zod';

/**
 * Communication surface — shared vocabulary for {@link Conversation},
 * {@link ConversationMessage}, leads, tickets, and the `doc` envelope.
 *
 * Lives in a `common` leaf so `doc.schema` can reference it without
 * importing a model (which would close a barrel cycle).
 */
export const conversationChannelTypeSchema = z.enum([
  'in_app',
  'whatsapp',
  'email',
  'sms',
  'voice',
]);
export type ConversationChannelType = z.infer<typeof conversationChannelTypeSchema>;
